export const articles = [
    {
        slug: "mantenimientoweb",
        image: "/assets/blog/mantenimiento.webp",
        publishedAt: "2025-06-09",
        updatedAt: "2026-07-28",
        readingMinutes: 6,
        content: {
            es: {
                title: "Mantenimiento web: cómo proteger velocidad, seguridad y posicionamiento",
                summary: "Una web necesita revisiones constantes. Te explicamos qué mantener, con qué frecuencia y por qué prevenir resulta más económico que reparar.",
                sections: [
                    {
                        heading: "Publicar no es el final",
                        paragraphs: [
                            "Frameworks, navegadores, sistemas operativos y amenazas cambian. Aunque el diseño siga viéndose bien, una dependencia desactualizada, un formulario roto o una copia de seguridad incompleta pueden convertir una pequeña falla en una interrupción costosa.",
                            "El mantenimiento profesional combina prevención, seguimiento y mejora. No consiste en instalar actualizaciones a ciegas, sino en probarlas y comprobar que el sitio continúe cumpliendo su objetivo.",
                        ],
                    },
                    {
                        heading: "Qué debería incluir",
                        bullets: [
                            "Actualización controlada de dependencias, servidor y certificados.",
                            "Backups automáticos con pruebas periódicas de restauración.",
                            "Monitoreo de disponibilidad, errores, formularios y enlaces.",
                            "Optimización de imágenes, caché, código y Core Web Vitals.",
                            "Revisión de permisos, accesos, registros y prácticas de seguridad.",
                            "Actualización de contenido, metadatos, sitemap y datos estructurados.",
                        ],
                    },
                    {
                        heading: "Una frecuencia razonable",
                        paragraphs: [
                            "Las copias y el monitoreo deben ser automáticos. Las dependencias y formularios conviene revisarlos mensualmente; el contenido y el SEO, al menos trimestralmente. Una auditoría más amplia puede realizarse cada seis o doce meses según el tráfico y la importancia comercial.",
                            "Un e-commerce o una plataforma con usuarios requiere controles más frecuentes que una landing estática. La frecuencia correcta depende del riesgo, no de una receta universal.",
                        ],
                    },
                    {
                        heading: "El beneficio real",
                        paragraphs: [
                            "Una rutina clara reduce caídas, mantiene la confianza del usuario y permite mejorar con datos. También evita que el equipo dependa de recordar manualmente tareas críticas.",
                            "El mejor mantenimiento es casi invisible: los visitantes simplemente encuentran una experiencia rápida, segura y disponible.",
                        ],
                    },
                ],
                cta: "Quiero un plan de mantenimiento",
            },
            en: {
                title: "Website maintenance: protecting speed, security and visibility",
                summary: "A website needs regular attention. Here is what to maintain, how often to review it and why prevention costs less than recovery.",
                sections: [
                    {
                        heading: "Launch is not the finish line",
                        paragraphs: [
                            "Frameworks, browsers, operating systems and threats keep changing. A site may still look right whilst an outdated dependency, broken form or incomplete backup quietly creates significant risk.",
                            "Professional maintenance combines prevention, monitoring and improvement. It is not about installing updates blindly; each change should be tested against the experience the site must deliver.",
                        ],
                    },
                    {
                        heading: "What good maintenance includes",
                        bullets: [
                            "Controlled updates for dependencies, servers and certificates.",
                            "Automated backups with regular restoration tests.",
                            "Availability, error, form and broken-link monitoring.",
                            "Image, cache, code and Core Web Vitals optimisation.",
                            "Reviews of permissions, access, logs and security practices.",
                            "Updates to content, metadata, sitemaps and structured data.",
                        ],
                    },
                    {
                        heading: "A sensible cadence",
                        paragraphs: [
                            "Backups and monitoring should be automated. Dependencies and forms deserve a monthly check; content and search visibility should be reviewed at least quarterly. A broader audit can take place every six or twelve months.",
                            "An online shop or user platform needs more frequent checks than a static landing page. The right cadence follows risk rather than a universal checklist.",
                        ],
                    },
                    {
                        heading: "The practical benefit",
                        paragraphs: [
                            "A clear routine reduces downtime, protects trust and creates room for evidence-led improvements. It also prevents critical work from relying on somebody remembering it.",
                            "The best maintenance is almost invisible: visitors simply receive a quick, secure and dependable experience.",
                        ],
                    },
                ],
                cta: "Discuss a maintenance plan",
            },
            it: {
                title: "Manutenzione web: proteggere velocità, sicurezza e visibilità",
                summary: "Un sito richiede controlli regolari. Vediamo cosa mantenere, con quale frequenza e perché prevenire costa meno che riparare.",
                sections: [
                    {
                        heading: "La pubblicazione non è il traguardo",
                        paragraphs: [
                            "Framework, browser, sistemi operativi e minacce continuano a cambiare. Un sito può sembrare perfetto mentre una dipendenza obsoleta, un modulo guasto o un backup incompleto creano un rischio concreto.",
                            "La manutenzione professionale unisce prevenzione, monitoraggio e miglioramento. Gli aggiornamenti vanno testati rispetto all’esperienza che il sito deve offrire.",
                        ],
                    },
                    {
                        heading: "Che cosa comprende",
                        bullets: [
                            "Aggiornamenti controllati di dipendenze, server e certificati.",
                            "Backup automatici con test periodici di ripristino.",
                            "Monitoraggio di disponibilità, errori, moduli e link.",
                            "Ottimizzazione di immagini, cache, codice e Core Web Vitals.",
                            "Revisione di permessi, accessi, log e pratiche di sicurezza.",
                            "Aggiornamento di contenuti, metadata, sitemap e dati strutturati.",
                        ],
                    },
                    {
                        heading: "Una frequenza sensata",
                        paragraphs: [
                            "Backup e monitoraggio dovrebbero essere automatici. Dipendenze e moduli meritano un controllo mensile; contenuti e SEO almeno trimestrale. Un audit completo può essere semestrale o annuale.",
                            "Un e-commerce o una piattaforma con utenti richiede verifiche più frequenti di una landing statica. La frequenza segue il rischio.",
                        ],
                    },
                    {
                        heading: "Il vantaggio concreto",
                        paragraphs: [
                            "Una routine chiara riduce le interruzioni, protegge la fiducia e permette di migliorare con i dati. Evita inoltre che attività critiche dipendano dalla memoria di una persona.",
                            "La manutenzione migliore è quasi invisibile: l’utente trova semplicemente un’esperienza veloce, sicura e affidabile.",
                        ],
                    },
                ],
                cta: "Parliamo di manutenzione",
            },
        },
    },
    {
        slug: "presencia-online",
        image: "/assets/blog/presencia-online.webp",
        publishedAt: "2025-06-09",
        updatedAt: "2026-07-28",
        readingMinutes: 7,
        content: {
            es: {
                title: "Cómo construir una presencia online que atraiga clientes",
                summary: "Una estrategia práctica para conectar marca, web, buscadores y canales de contacto sin depender de una sola plataforma.",
                sections: [
                    {
                        heading: "Primero: entender el negocio",
                        paragraphs: [
                            "Antes de diseñar hay que definir qué problema resolvés, para quién y por qué deberían elegirte. Esa respuesta determina los mensajes, páginas, llamados a la acción y búsquedas que vale la pena trabajar.",
                            "También conviene revisar cómo llegan hoy las consultas y dónde se pierden. La mejor estrategia digital fortalece el recorrido comercial existente.",
                        ],
                    },
                    {
                        heading: "Una identidad coherente",
                        paragraphs: [
                            "Logo, colores y tipografías importan, pero la coherencia también está en el tono, las fotografías, las promesas y la manera de explicar el servicio. Cada punto de contacto debería parecer parte de la misma empresa.",
                            "La web actúa como centro: allí se ordenan la propuesta, las pruebas, los proyectos, las preguntas frecuentes y los canales de contacto.",
                        ],
                    },
                    {
                        heading: "Integraciones que reducen fricción",
                        bullets: [
                            "Perfil de Empresa de Google y mapas para búsquedas locales.",
                            "WhatsApp, email y formularios con mensajes y seguimiento claros.",
                            "Analítica orientada a conversiones, no solamente a visitas.",
                            "Redes sociales conectadas con páginas específicas, no siempre con la portada.",
                            "Automatizaciones simples para confirmar y organizar consultas.",
                        ],
                    },
                    {
                        heading: "Promoción y aprendizaje",
                        paragraphs: [
                            "SEO, contenidos y anuncios pueden convivir. Lo importante es que cada campaña llegue a una página relevante y que la medición permita saber qué genera conversaciones reales.",
                            "Una presencia profesional se construye por iteraciones: publicar, medir, escuchar preguntas comerciales y mejorar el contenido.",
                        ],
                    },
                ],
                cta: "Quiero ordenar mi presencia digital",
            },
            en: {
                title: "How to build an online presence that attracts clients",
                summary: "A practical approach to connecting brand, website, search and contact channels without relying on a single platform.",
                sections: [
                    {
                        heading: "Start by understanding the business",
                        paragraphs: [
                            "Before design begins, define the problem you solve, who experiences it and why they should choose you. Those answers shape the messages, pages, calls to action and searches worth targeting.",
                            "Review how enquiries arrive today and where they are lost. The strongest digital strategy supports the commercial journey you already have.",
                        ],
                    },
                    {
                        heading: "A coherent identity",
                        paragraphs: [
                            "Logos, colours and type matter, but consistency also lives in tone, photography, promises and the way a service is explained. Every touchpoint should feel like the same organisation.",
                            "The website becomes the centre: it organises your proposition, evidence, work, frequently asked questions and contact routes.",
                        ],
                    },
                    {
                        heading: "Integrations that remove friction",
                        bullets: [
                            "Google Business Profile and maps for local discovery.",
                            "WhatsApp, email and forms with clear messages and follow-up.",
                            "Analytics centred on conversions rather than visits alone.",
                            "Social links that lead to relevant pages, not always the home page.",
                            "Simple automation to confirm and organise enquiries.",
                        ],
                    },
                    {
                        heading: "Promotion and learning",
                        paragraphs: [
                            "SEO, useful content and paid campaigns can work together. Each campaign should land on a relevant page, whilst measurement should reveal which activity creates genuine conversations.",
                            "A professional presence grows in iterations: publish, measure, listen to commercial questions and improve the content.",
                        ],
                    },
                ],
                cta: "Organise my digital presence",
            },
            it: {
                title: "Come costruire una presenza online che attira clienti",
                summary: "Un approccio pratico per collegare brand, sito, ricerca e canali di contatto senza dipendere da una sola piattaforma.",
                sections: [
                    {
                        heading: "Partire dal business",
                        paragraphs: [
                            "Prima del design bisogna definire quale problema risolvi, per chi e perché dovrebbe scegliere te. Le risposte determinano messaggi, pagine, inviti all’azione e ricerche da presidiare.",
                            "È utile osservare come arrivano oggi le richieste e dove si perdono. La strategia digitale migliore rafforza il percorso commerciale esistente.",
                        ],
                    },
                    {
                        heading: "Un’identità coerente",
                        paragraphs: [
                            "Logo, colori e tipografia contano, ma la coerenza vive anche nel tono, nelle immagini, nelle promesse e nel modo di spiegare il servizio.",
                            "Il sito diventa il centro: organizza proposta, prove, progetti, domande frequenti e canali di contatto.",
                        ],
                    },
                    {
                        heading: "Integrazioni che riducono l’attrito",
                        bullets: [
                            "Profilo dell’attività su Google e mappe per le ricerche locali.",
                            "WhatsApp, email e moduli con messaggi e follow-up chiari.",
                            "Analytics orientata alle conversioni, non solo alle visite.",
                            "Social collegati a pagine pertinenti, non sempre alla home.",
                            "Automazioni semplici per confermare e organizzare le richieste.",
                        ],
                    },
                    {
                        heading: "Promozione e apprendimento",
                        paragraphs: [
                            "SEO, contenuti e campagne possono convivere. Ogni attività deve portare a una pagina pertinente e la misurazione deve mostrare cosa genera conversazioni reali.",
                            "Una presenza professionale cresce per iterazioni: pubblicare, misurare, ascoltare le domande commerciali e migliorare.",
                        ],
                    },
                ],
                cta: "Organizziamo la mia presenza digitale",
            },
        },
    },
    {
        slug: "optimizacion-posicionamiento",
        image: "/assets/blog/optimizacionweb.webp",
        publishedAt: "2025-06-09",
        updatedAt: "2026-07-28",
        readingMinutes: 7,
        content: {
            es: {
                title: "Optimización web: rendimiento, experiencia y posicionamiento",
                summary: "Qué revisar para que una web cargue rápido, sea comprensible para Google y ayude a las personas a completar una acción.",
                sections: [
                    {
                        heading: "Rendimiento que se siente",
                        paragraphs: [
                            "Optimizar no consiste sólo en reducir un número. Una página rápida permite que el contenido principal aparezca pronto, responda sin demoras y no cambie de lugar mientras el usuario intenta interactuar.",
                            "Las métricas LCP, INP y CLS ayudan a detectar esos problemas, pero deben combinarse con pruebas reales en móviles, redes lentas y dispositivos menos potentes.",
                        ],
                    },
                    {
                        heading: "Decisiones técnicas de alto impacto",
                        bullets: [
                            "Imágenes AVIF o WebP con dimensiones y carga adecuadas.",
                            "Fuentes limitadas, alojadas o cargadas sin bloquear el contenido.",
                            "JavaScript únicamente donde aporta una interacción real.",
                            "Caché, compresión y CDN configurados según el tipo de recurso.",
                            "Renderizado y respuesta del servidor acordes al contenido.",
                        ],
                    },
                    {
                        heading: "SEO técnico que elimina obstáculos",
                        paragraphs: [
                            "URLs estables, enlaces internos, sitemap, canonicales y hreflang ayudan a los buscadores a encontrar la versión correcta de cada página. Los datos estructurados aportan contexto cuando representan fielmente el contenido visible.",
                            "La indexación no reemplaza la relevancia. Cada página debe responder una intención concreta con contenido útil y una jerarquía fácil de recorrer.",
                        ],
                    },
                    {
                        heading: "Medir después de publicar",
                        paragraphs: [
                            "Lighthouse es una buena herramienta de diagnóstico, pero representa una prueba de laboratorio. Search Console, Analytics y los datos reales de Core Web Vitals muestran cómo funciona la experiencia para visitantes verdaderos.",
                            "El trabajo sostenido consiste en comparar, priorizar y corregir los obstáculos que afectan negocio y usuario.",
                        ],
                    },
                ],
                cta: "Auditar el rendimiento de mi web",
            },
            en: {
                title: "Website optimisation: performance, experience and search",
                summary: "What to review so a site loads quickly, makes sense to search engines and helps people complete a meaningful action.",
                sections: [
                    {
                        heading: "Performance people can feel",
                        paragraphs: [
                            "Optimisation is not just about reducing a score. A quick page reveals its main content promptly, responds without delay and avoids moving whilst someone tries to interact.",
                            "LCP, INP and CLS help uncover those issues, but they should be paired with real tests on mobile connections and less powerful devices.",
                        ],
                    },
                    {
                        heading: "High-impact technical choices",
                        bullets: [
                            "Correctly sized AVIF or WebP images with appropriate loading.",
                            "A restrained font set that does not block content.",
                            "JavaScript only where it provides a genuine interaction.",
                            "Caching, compression and CDN behaviour suited to each asset.",
                            "Rendering and server response chosen for the content.",
                        ],
                    },
                    {
                        heading: "Technical SEO that removes obstacles",
                        paragraphs: [
                            "Stable URLs, internal links, sitemaps, canonicals and hreflang help search engines find the right version of every page. Structured data provides context when it honestly reflects visible content.",
                            "Indexability does not replace relevance. Each page should answer a clear intention with useful content and an easy hierarchy.",
                        ],
                    },
                    {
                        heading: "Measure after launch",
                        paragraphs: [
                            "Lighthouse is a useful diagnostic tool, but it remains a laboratory test. Search Console, Analytics and field Core Web Vitals show how the experience works for real visitors.",
                            "Sustained optimisation means comparing evidence, prioritising and removing the obstacles that affect both customers and the business.",
                        ],
                    },
                ],
                cta: "Audit my website performance",
            },
            it: {
                title: "Ottimizzazione web: prestazioni, esperienza e ricerca",
                summary: "Che cosa verificare affinché un sito sia veloce, comprensibile per i motori di ricerca e utile alle persone.",
                sections: [
                    {
                        heading: "Prestazioni percepibili",
                        paragraphs: [
                            "Ottimizzare non significa soltanto migliorare un punteggio. Una pagina veloce mostra presto il contenuto principale, risponde senza ritardi e non cambia posizione durante l’interazione.",
                            "LCP, INP e CLS aiutano a individuare questi problemi, ma vanno affiancati da test reali su mobile e dispositivi meno potenti.",
                        ],
                    },
                    {
                        heading: "Scelte tecniche ad alto impatto",
                        bullets: [
                            "Immagini AVIF o WebP con dimensioni e caricamento corretti.",
                            "Un set di font limitato che non blocchi il contenuto.",
                            "JavaScript solo dove offre un’interazione reale.",
                            "Cache, compressione e CDN adeguati a ogni risorsa.",
                            "Rendering e risposta del server scelti in base al contenuto.",
                        ],
                    },
                    {
                        heading: "SEO tecnico che elimina gli ostacoli",
                        paragraphs: [
                            "URL stabili, link interni, sitemap, canonical e hreflang aiutano i motori di ricerca a trovare la versione corretta. I dati strutturati danno contesto quando descrivono ciò che è realmente visibile.",
                            "L’indicizzazione non sostituisce la rilevanza: ogni pagina deve rispondere a un’intenzione precisa.",
                        ],
                    },
                    {
                        heading: "Misurare dopo il lancio",
                        paragraphs: [
                            "Lighthouse è utile per la diagnosi, ma resta un test di laboratorio. Search Console, Analytics e i Core Web Vitals sul campo mostrano l’esperienza reale.",
                            "L’ottimizzazione continua significa confrontare i dati, stabilire priorità e rimuovere gli ostacoli per utenti e business.",
                        ],
                    },
                ],
                cta: "Valutare le prestazioni del mio sito",
            },
        },
    },
    {
        slug: "sitioweb-profesional",
        image: "/assets/blog/moderndesign.webp",
        publishedAt: "2025-05-28",
        updatedAt: "2026-07-28",
        readingMinutes: 6,
        content: {
            es: {
                title: "Cuánto cuesta una página web profesional en 2026",
                summary: "No existe un precio único. Te mostramos qué variables forman un presupuesto y cómo comparar propuestas sin decidir sólo por el número final.",
                sections: [
                    {
                        heading: "El precio sigue al alcance",
                        paragraphs: [
                            "Una landing para validar una propuesta, un sitio corporativo multilingüe y un e-commerce con panel administrativo resuelven necesidades muy distintas. El presupuesto refleja investigación, diseño, contenido, desarrollo, integraciones, pruebas y acompañamiento.",
                            "Por eso un precio sin alcance detallado dice poco. Dos propuestas pueden llamarse “página web” y contener cantidades de trabajo completamente diferentes.",
                        ],
                    },
                    {
                        heading: "Variables que cambian la inversión",
                        bullets: [
                            "Cantidad y complejidad de páginas, idiomas y recorridos.",
                            "Diseño original frente a adaptación de un sistema existente.",
                            "Administración de contenido, usuarios, pagos o automatizaciones.",
                            "Integraciones con servicios y sistemas externos.",
                            "Fotografía, redacción, migración y carga de información.",
                            "SEO, analítica, accesibilidad, rendimiento y soporte posterior.",
                        ],
                    },
                    {
                        heading: "Cómo comparar propuestas",
                        paragraphs: [
                            "Pedí que cada presupuesto explique entregables, tecnología, propiedad del código, revisiones, plazos, publicación, mantenimiento y costos recurrentes. También debería aclarar qué necesita entregar el cliente.",
                            "Revisá proyectos reales y preguntá cómo se medirán los resultados. El proveedor adecuado debe poder explicar decisiones sin esconderse detrás de jerga.",
                        ],
                    },
                    {
                        heading: "Invertir por etapas",
                        paragraphs: [
                            "Cuando el presupuesto es limitado, conviene priorizar una primera versión sólida y medible, no repartir recursos entre muchas funciones incompletas. Una arquitectura correcta permite sumar capacidades cuando existe evidencia para hacerlo.",
                            "La mejor inversión no siempre es la propuesta más cara o la más económica, sino la que resuelve el objetivo con un alcance claro.",
                        ],
                    },
                ],
                cta: "Cotizar mi proyecto",
            },
            en: {
                title: "What a professional website costs in 2026",
                summary: "There is no universal figure. We explain what shapes an estimate and how to compare proposals without choosing by price alone.",
                sections: [
                    {
                        heading: "Price follows scope",
                        paragraphs: [
                            "A landing page used to validate a proposition, a multilingual corporate site and an online shop with an admin panel solve very different problems. An estimate covers research, design, content, development, integrations, testing and support.",
                            "A price without a defined scope says very little. Two proposals may both be called a ‘website’ whilst containing entirely different amounts of work.",
                        ],
                    },
                    {
                        heading: "What changes the investment",
                        bullets: [
                            "The number and complexity of pages, languages and journeys.",
                            "Original design versus adapting an existing system.",
                            "Content management, users, payments or automation.",
                            "Integrations with external services and business systems.",
                            "Photography, copy, migration and initial content entry.",
                            "SEO, analytics, accessibility, performance and aftercare.",
                        ],
                    },
                    {
                        heading: "How to compare proposals",
                        paragraphs: [
                            "Ask each proposal to explain deliverables, technology, code ownership, revisions, timings, publishing, maintenance and recurring costs. It should also state what the client needs to provide.",
                            "Review real work and ask how outcomes will be measured. A suitable partner can explain decisions without hiding behind jargon.",
                        ],
                    },
                    {
                        heading: "Investing in stages",
                        paragraphs: [
                            "With a limited budget, prioritise a robust and measurable first version rather than spreading resources across many unfinished features. Sound architecture makes it possible to add capabilities when evidence supports them.",
                            "The best investment is not automatically the cheapest or most expensive proposal. It is the one that addresses the objective with a clear scope.",
                        ],
                    },
                ],
                cta: "Estimate my project",
            },
            it: {
                title: "Quanto costa un sito professionale nel 2026",
                summary: "Non esiste un prezzo universale. Vediamo che cosa forma un preventivo e come confrontare le proposte senza scegliere solo dal totale.",
                sections: [
                    {
                        heading: "Il prezzo segue il perimetro",
                        paragraphs: [
                            "Una landing per validare una proposta, un sito aziendale multilingue e un e-commerce con pannello admin risolvono problemi diversi. Il preventivo comprende ricerca, design, contenuti, sviluppo, integrazioni, test e supporto.",
                            "Un prezzo senza perimetro dice poco. Due proposte chiamate entrambe “sito web” possono contenere quantità di lavoro completamente differenti.",
                        ],
                    },
                    {
                        heading: "Che cosa cambia l’investimento",
                        bullets: [
                            "Numero e complessità di pagine, lingue e percorsi.",
                            "Design originale o adattamento di un sistema esistente.",
                            "Gestione contenuti, utenti, pagamenti o automazioni.",
                            "Integrazioni con servizi e sistemi esterni.",
                            "Fotografia, testi, migrazione e caricamento iniziale.",
                            "SEO, analytics, accessibilità, prestazioni e assistenza.",
                        ],
                    },
                    {
                        heading: "Come confrontare le proposte",
                        paragraphs: [
                            "Chiedi che ogni preventivo descriva consegne, tecnologia, proprietà del codice, revisioni, tempi, pubblicazione, manutenzione e costi ricorrenti.",
                            "Osserva progetti reali e chiedi come saranno misurati i risultati. Il partner giusto sa spiegare le scelte senza nascondersi nel gergo.",
                        ],
                    },
                    {
                        heading: "Investire per fasi",
                        paragraphs: [
                            "Con un budget limitato è meglio una prima versione solida e misurabile che molte funzioni incomplete. Una buona architettura consente di crescere quando i dati lo giustificano.",
                            "L’investimento migliore non è sempre quello più economico o costoso, ma quello che risolve l’obiettivo con un perimetro chiaro.",
                        ],
                    },
                ],
                cta: "Richiedi un preventivo",
            },
        },
    },
    {
        slug: "webprogramada-vs-constructores",
        image: "/assets/blog/codevsbuilder.webp",
        publishedAt: "2025-05-28",
        updatedAt: "2026-07-28",
        readingMinutes: 6,
        content: {
            es: {
                title: "Web a medida vs. Wix, Shopify y otros constructores",
                summary: "Ambos enfoques pueden ser válidos. La decisión correcta depende de velocidad de salida, diferenciación, operación y crecimiento esperado.",
                sections: [
                    {
                        heading: "Cuándo conviene un constructor",
                        paragraphs: [
                            "Una plataforma administrada puede ser adecuada para validar rápidamente, operar un catálogo estándar o trabajar con un presupuesto inicial reducido. Hosting, editor y algunas integraciones vienen resueltos.",
                            "La contrapartida es aceptar el modelo, las capacidades y los costos recurrentes del proveedor. No es necesariamente malo: es una decisión de negocio.",
                        ],
                    },
                    {
                        heading: "Qué aporta un desarrollo a medida",
                        bullets: [
                            "Identidad visual y recorridos diseñados alrededor de la propuesta.",
                            "Control sobre rendimiento, accesibilidad y comportamiento.",
                            "Integraciones específicas con procesos y sistemas del negocio.",
                            "Posibilidad de escalar sin depender del catálogo de extensiones.",
                            "Propiedad y portabilidad acordadas del código y los datos.",
                        ],
                    },
                    {
                        heading: "SEO y rendimiento sin mitos",
                        paragraphs: [
                            "Los constructores modernos pueden posicionar y alcanzar buen rendimiento si se configuran correctamente. El desarrollo a medida ofrece más control, pero ese potencial sólo sirve cuando el equipo lo utiliza bien.",
                            "La diferencia decisiva suele aparecer en requisitos especiales, diseño, integración y costo total a medida que el proyecto crece.",
                        ],
                    },
                    {
                        heading: "Una pregunta más útil",
                        paragraphs: [
                            "En lugar de preguntar qué herramienta es mejor en abstracto, definí qué debe hacer el producto durante los próximos dos años, qué procesos necesita conectar y qué dependencia estás dispuesto a aceptar.",
                            "Con ese contexto resulta mucho más sencillo elegir entre velocidad inicial y libertad de evolución.",
                        ],
                    },
                ],
                cta: "Elegir la arquitectura correcta",
            },
            en: {
                title: "Bespoke development vs Wix, Shopify and site builders",
                summary: "Both approaches can be valid. The right choice depends on launch speed, differentiation, operations and expected growth.",
                sections: [
                    {
                        heading: "When a builder makes sense",
                        paragraphs: [
                            "A managed platform can suit quick validation, a standard catalogue or a modest initial budget. Hosting, editing and common integrations arrive as part of the service.",
                            "In return, the business accepts the provider’s model, capabilities and recurring charges. That is not inherently wrong; it is a commercial choice.",
                        ],
                    },
                    {
                        heading: "What bespoke development offers",
                        bullets: [
                            "Visual identity and journeys designed around the proposition.",
                            "Control over performance, accessibility and behaviour.",
                            "Specific integrations with business processes and systems.",
                            "Room to scale beyond an extension marketplace.",
                            "Agreed ownership and portability of code and data.",
                        ],
                    },
                    {
                        heading: "SEO and performance without myths",
                        paragraphs: [
                            "Modern builders can rank and perform well when configured carefully. Bespoke development provides greater control, but that potential matters only when the team uses it effectively.",
                            "The decisive difference usually appears in specialist requirements, design, integration and total cost as the project grows.",
                        ],
                    },
                    {
                        heading: "A more useful question",
                        paragraphs: [
                            "Rather than asking which tool is universally best, define what the product must do over the next two years, which processes it needs to connect and how much platform dependency is acceptable.",
                            "That context makes the choice between initial speed and long-term freedom much clearer.",
                        ],
                    },
                ],
                cta: "Choose the right architecture",
            },
            it: {
                title: "Sviluppo su misura vs Wix, Shopify e website builder",
                summary: "Entrambi gli approcci possono funzionare. La scelta dipende da velocità, differenziazione, operatività e crescita prevista.",
                sections: [
                    {
                        heading: "Quando conviene un builder",
                        paragraphs: [
                            "Una piattaforma gestita può essere adatta per validare rapidamente, operare un catalogo standard o partire con un budget contenuto. Hosting, editor e integrazioni comuni sono già disponibili.",
                            "In cambio l’azienda accetta modello, capacità e costi ricorrenti del fornitore. Non è necessariamente negativo: è una scelta commerciale.",
                        ],
                    },
                    {
                        heading: "Che cosa offre lo sviluppo su misura",
                        bullets: [
                            "Identità e percorsi progettati intorno alla proposta.",
                            "Controllo su prestazioni, accessibilità e comportamento.",
                            "Integrazioni specifiche con processi e sistemi aziendali.",
                            "Crescita non limitata dal catalogo delle estensioni.",
                            "Proprietà e portabilità concordate di codice e dati.",
                        ],
                    },
                    {
                        heading: "SEO e prestazioni senza miti",
                        paragraphs: [
                            "I builder moderni possono posizionarsi e funzionare bene se configurati con cura. Lo sviluppo su misura dà più controllo, ma questo potenziale conta solo se viene sfruttato.",
                            "La differenza emerge spesso nei requisiti speciali, nel design, nelle integrazioni e nel costo totale durante la crescita.",
                        ],
                    },
                    {
                        heading: "Una domanda più utile",
                        paragraphs: [
                            "Invece di chiedere quale strumento sia migliore in assoluto, definisci cosa dovrà fare il prodotto nei prossimi due anni, quali processi deve collegare e quanta dipendenza è accettabile.",
                            "Il contesto chiarisce la scelta fra velocità iniziale e libertà futura.",
                        ],
                    },
                ],
                cta: "Scegliere l’architettura giusta",
            },
        },
    },
    {
        slug: "seo",
        image: "/assets/blog/seo.webp",
        publishedAt: "2025-05-28",
        updatedAt: "2026-07-28",
        readingMinutes: 6,
        content: {
            es: {
                title: "SEO para emprendedores: cómo empezar a aparecer en Google",
                summary: "Una introducción sin promesas mágicas: intención de búsqueda, contenido útil, base técnica y autoridad construida con tiempo.",
                sections: [
                    {
                        heading: "Qué es realmente el SEO",
                        paragraphs: [
                            "SEO reúne prácticas que ayudan a los buscadores a descubrir, comprender y considerar relevante una página. No garantiza el primer puesto ni produce resultados instantáneos.",
                            "El punto de partida es entender qué intenta resolver una persona cuando busca y crear la mejor respuesta que tu negocio pueda ofrecer.",
                        ],
                    },
                    {
                        heading: "La base que podés trabajar hoy",
                        bullets: [
                            "Una página específica y clara para cada servicio importante.",
                            "Títulos y contenido escritos con el lenguaje real de tus clientes.",
                            "Una web rápida, accesible, móvil y fácil de recorrer.",
                            "Perfil de Empresa de Google completo para búsquedas locales.",
                            "Enlaces internos que conecten servicios, casos y artículos.",
                            "Medición en Search Console y Analytics.",
                        ],
                    },
                    {
                        heading: "Contenido con propósito",
                        paragraphs: [
                            "Un blog funciona cuando responde preguntas vinculadas con una decisión comercial. Publicar por calendario sin aportar algo mejor que los resultados existentes rara vez ayuda.",
                            "Casos de trabajo, comparaciones honestas, procesos y preguntas frecuentes pueden demostrar experiencia y atraer búsquedas relevantes.",
                        ],
                    },
                    {
                        heading: "Autoridad y paciencia",
                        paragraphs: [
                            "Menciones de medios, directorios confiables, asociaciones y enlaces editoriales ayudan a construir reputación. Comprar enlaces indiscriminadamente puede generar el efecto contrario.",
                            "El SEO es acumulativo: una base técnica sana, contenido útil y mejora constante producen una fuente de demanda menos dependiente de publicidad.",
                        ],
                    },
                ],
                cta: "Construir mi base SEO",
            },
            en: {
                title: "SEO for small businesses: how to begin appearing in Google",
                summary: "An introduction without magical promises: search intent, useful content, technical foundations and authority built over time.",
                sections: [
                    {
                        heading: "What SEO actually means",
                        paragraphs: [
                            "SEO brings together practices that help search engines discover, understand and consider a page relevant. It cannot guarantee first place or instant results.",
                            "The starting point is understanding what someone is trying to solve when they search, then creating the best answer your business can genuinely provide.",
                        ],
                    },
                    {
                        heading: "The foundation you can build today",
                        bullets: [
                            "A clear, specific page for each important service.",
                            "Titles and content written in the language customers actually use.",
                            "A quick, accessible, mobile-friendly site that is easy to navigate.",
                            "A complete Google Business Profile for local searches.",
                            "Internal links connecting services, case studies and articles.",
                            "Measurement through Search Console and Analytics.",
                        ],
                    },
                    {
                        heading: "Content with a purpose",
                        paragraphs: [
                            "A journal works when it answers questions linked to a commercial decision. Publishing to fill a calendar without improving on existing results rarely helps.",
                            "Case studies, honest comparisons, processes and frequently asked questions can demonstrate experience and attract relevant searches.",
                        ],
                    },
                    {
                        heading: "Authority and patience",
                        paragraphs: [
                            "Mentions from publications, credible directories, associations and editorial links help establish reputation. Indiscriminate link buying can have the opposite effect.",
                            "SEO compounds: healthy foundations, useful content and consistent improvement create demand that is less dependent on advertising.",
                        ],
                    },
                ],
                cta: "Build my SEO foundation",
            },
            it: {
                title: "SEO per piccole imprese: come iniziare a comparire su Google",
                summary: "Un’introduzione senza promesse magiche: intento di ricerca, contenuti utili, base tecnica e autorevolezza costruita nel tempo.",
                sections: [
                    {
                        heading: "Che cos’è davvero la SEO",
                        paragraphs: [
                            "La SEO riunisce pratiche che aiutano i motori di ricerca a scoprire, comprendere e considerare rilevante una pagina. Non garantisce il primo posto né risultati immediati.",
                            "Il punto di partenza è capire che cosa vuole risolvere una persona quando cerca e creare la migliore risposta che l’azienda possa offrire.",
                        ],
                    },
                    {
                        heading: "La base da costruire oggi",
                        bullets: [
                            "Una pagina chiara e specifica per ogni servizio importante.",
                            "Titoli e contenuti scritti con il linguaggio reale dei clienti.",
                            "Un sito veloce, accessibile, mobile e facile da navigare.",
                            "Un Profilo dell’attività su Google completo per le ricerche locali.",
                            "Link interni tra servizi, casi e articoli.",
                            "Misurazione con Search Console e Analytics.",
                        ],
                    },
                    {
                        heading: "Contenuti con uno scopo",
                        paragraphs: [
                            "Un journal funziona quando risponde a domande collegate a una decisione commerciale. Pubblicare solo per riempire un calendario raramente aiuta.",
                            "Casi studio, confronti onesti, processi e domande frequenti possono dimostrare esperienza e intercettare ricerche pertinenti.",
                        ],
                    },
                    {
                        heading: "Autorevolezza e pazienza",
                        paragraphs: [
                            "Citazioni su pubblicazioni, directory affidabili, associazioni e link editoriali costruiscono reputazione. Acquistare link senza criterio può produrre l’effetto opposto.",
                            "La SEO è cumulativa: fondamenta sane, contenuti utili e miglioramento costante creano domanda meno dipendente dalla pubblicità.",
                        ],
                    },
                ],
                cta: "Costruire la mia base SEO",
            },
        },
    },
];
export function getArticle(slug) {
    return articles.find((article) => article.slug === slug);
}
